import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateAccommodation($companyId: ID!, $id: ID!, $attributes: AccommodationAttributes!) {
    updateAccommodation(companyId: $companyId, id: $id, attributes: $attributes) {
      accommodation {
        id
        ...UpdatedAccommodation
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedAccommodation on Accommodation {
    id
    name
    address
    address1
    address2
    address3
    city
    county
    postcode
  }
`
